/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { N800 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { SmallCapsHeading } from '@af/design-system-docs-ui';

const headingItemStyles = css({
  paddingBottom: token('space.150', '12px'),
  paddingLeft: token('space.400', '32px'),
  '&:first-of-type': {
    paddingTop: token('space.400', '32px'),
  },
});

type HeadingItemProps = { children: React.ReactNode; testId?: string };

/**
 * __Heading item__
 *
 * Displays a heading inside the side navigation.
 */
const HeadingItem = ({ children, testId }: HeadingItemProps) => (
  <div css={headingItemStyles} data-testid={testId}>
    <SmallCapsHeading as="h2" color={token('color.text', N800)}>
      {children}
    </SmallCapsHeading>
  </div>
);

export default HeadingItem;
